module.exports = __webpack_public_path__ + "static/iphonex-reportingtools-103ca0c4d986cda3980613e5a5fdc331.png";